import styles from './CommandFSearch.module.scss';

// An `id` used internally by `useCommandFSearch` for identifying text that should be highlighted
export const COMMAND_F_SEARCH_ID = 'commandFSearchID';

interface HiddenSearchableTextSpanProps {
  /* The text that will be hidden, but searchable on the page. */
  searchableText: string;
}

/**
 * Renders text that is hidden from the user's view, but is used with the browser's native
 * "command + f", AKA. "find", search functionality. This enables search for content on the page
 * without explicitly displaying the search text.
 */
export const HiddenSearchableTextSpan = ({ searchableText }: HiddenSearchableTextSpanProps) => (
  <span className={styles.commandFSearchText} id={COMMAND_F_SEARCH_ID}>
    {searchableText}
  </span>
);
